module.exports.name = 'decoracion'
module.exports.projects = [
    {
        url: '/soluciones-tecnicas/decoracion/decoracion',
        title: 'Decoración',
        image: () => require('./images/decoracion-1.jpg'),
        html: `
            "Para todos los gustos…texturas y colores"
            <br />
            <br />
            Pavimentos, paredes, mobiliario, a cualquier  cosa que se te ocurra, dale ese toque especial, singular y propio.
            <br />
            <br />
            Para ese nuevo proyecto tenemos una extensa gama en:
            <br />
            <br />
            <b>Micro-cementos, Estucos, Patinas efecto metal, etc...</b>
        `,
        htmlFull: () => `
            "Para todos los gustos…texturas y colores"
            <br />
            <br />
            Pavimentos, paredes, mobiliario, a cualquier  cosa que se te ocurra, dale ese toque especial, singular y propio.
            <br />
            <br />
            Para ese nuevo proyecto tenemos una extensa gama en:
            <br />
            <br />
            <b>Micro-cementos, Estucos, Patinas efecto metal, etc...</b>
            <br />
            <br />
            Microcementos Int-Ext para suelos,paredes,cuartos de baño,piscinas,escaleras...
            <img src="${require('./images/decoracion-1.jpg')}" />
            ...en definitiva recubre casi cualquier soporte, con nuestro micro cemento
            bicomponete en una gran gama de colores, tendremos el mejor sistema de aplicado, desde
            una barrera de vapor con resina epoxi, áridos de cuarzo, mallas de diferente gramaje,
            imprimaciones para soportes absorbentes y no absorbentes y como no nuestros poliuretanos
            bi-componentes mate-satinado brillante...
            <img src="${require('./images/decoracion-2.jpg')}" />
            Gama en patinas  metálicas, oro, plata, cobre, latón, acero corten, etc..
            Existiendo 2 posibilidades natural u oxidado...
            <img src="${require('./images/decoracion-3.jpg')}" />
            ...pinturas decorativa a base de polvo de metal. Crea verdaderas obras de arte...
            <img src="${require('./images/decoracion-4.jpg')}" />
            Estucos naturales a base de cal en pasta altamente transpirable, para exterior.  
            <img src="${require('./images/decoracion-5.jpg')}" />
            Espatolatos ,estuco fino,para interiores naturales altamente traspirable.
            Ambos se pueden colorear en una amplia gama de tonalidades
            <img src="${require('./images/decoracion-6.jpg')}" />
            Visite nuestras instalaciones poda ver muestras de nuestros productos y 
            quizás encuentre la inspiración para ese nuevo proyecto..
            <img src="${require('./images/decoracion-7.jpg')}" />
        `,
    },
]


// WEBPACK FOOTER //
// ./src/data/decoracion.js